import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import CastMobileMenuRes from "types/res/castMobileMenu/CastMobileMenuRes";
import { useDispatch, useSelector } from "react-redux";
import CastMobileMenuApi from "api/CastMobileMenuApi";
import FormLabel from "@material-ui/core/FormLabel";
import toastActions, { ToastType } from "redux/actions/toast";

const CastMobileMenu = () => {
  const { t } = useTranslation("castShift");
  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.account.staff.companyId);
  const [castMobileMenu, setCastMobileMenu] = useState<any>(
    {} as CastMobileMenuRes
  );
  useEffect(() => {
    const fetchData = async () => {
      const data = await CastMobileMenuApi.findOne(companyId);
      setCastMobileMenu(data);
    };
    fetchData();
  }, [companyId]);

  const onChange = (key: string, value: boolean) => {
    setCastMobileMenu({ ...castMobileMenu, [key]: value });
  };
  const menus = [
    {
      key: "isShiftDisplay",
      label: t("mobileMenu.menus.isShiftDisplay"),
    },
    {
      key: "isScheduleDisplay",
      label: t("mobileMenu.menus.isScheduleDisplay"),
    },
    {
      key: "isOrderDetailDisplay",
      label: t("mobileMenu.menus.isOrderDetailDisplay"),
    },
    {
      key: "isAttendanceDisplay",
      label: t("mobileMenu.menus.isAttendanceDisplay"),
    },
    {
      key: "isEmergencyDisplay",
      label: t("mobileMenu.menus.isEmergencyDisplay"),
    },
    {
      key: "isPayoffDisplay",
      label: t("mobileMenu.menus.isPayoffDisplay"),
    },
    {
      key: "isGuestNoteDisplay",
      label: t("mobileMenu.menus.isGuestNoteDisplay"),
    },
  ];

  return (
    <Box display={"flex"} flexDirection={"column"} padding={4}>
      <Typography variant={"h5"}>{t("mobileMenu.title")}</Typography>
      {menus.map((menu) => (
        <Box
          display={"flex"}
          flexDirection={"column"}
          marginY={2}
          key={menu.key}
        >
          <FormLabel component="legend">{menu.label}</FormLabel>
          <RadioGroup
            row
            aria-label={menu.key}
            name={menu.key}
            onChange={(event) => onChange(menu.key, event.target.value === "1")}
            value={castMobileMenu?.[menu.key]}
          >
            <FormControlLabel
              value="1"
              control={<Radio color="primary" />}
              label={t("mobileMenu.on")}
              checked={castMobileMenu?.[menu.key]}
            />
            <FormControlLabel
              value="0"
              control={<Radio color="primary" />}
              label={t("mobileMenu.off")}
              checked={!castMobileMenu?.[menu.key]}
            />
          </RadioGroup>
        </Box>
      ))}
      <Box>
        <Button
          variant={"contained"}
          color={"primary"}
          onClick={async () => {
            await CastMobileMenuApi.update(companyId, castMobileMenu);
            setCastMobileMenu(await CastMobileMenuApi.findOne(companyId));
            await dispatch(
              toastActions.showToast({
                text: t("mobileMenu.savedMessage"),
                type: ToastType.Success,
              })
            );
          }}
        >
          {t("mobileMenu.save")}
        </Button>
      </Box>
    </Box>
  );
};
export default CastMobileMenu;
